import { render, staticRenderFns } from "./DebtChart.vue?vue&type=template&id=5d96222a&"
import script from "./DebtChart.vue?vue&type=script&lang=js&"
export * from "./DebtChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports